module.exports = __webpack_public_path__ + "static/media/YF93_2.49fb1c29.jpg";